export const SET_USER = "setUser"
export const SET_HANDBOOK = "setHandbook"
export const SET_IMAGE = "setImage"
export const SHOW_NOTIFICATION = "showNotification"
export const SET_MESSAGE = "setMessage"
export const ADD_SECTION = "addSection"
export const SET_SECTIONS = "setSections"
export const SET_SECTION = "setSection"
export const REMOVE_SECTION = "removeSection"
export const RESET_SECTION = "resetSection"
